import React from "react"

interface ExternalLinkButtonProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string
  children: React.ReactNode
}

export const ExternalLinkWrapper = ({
  href,
  children,
  ...rest
}: ExternalLinkButtonProps) => {
  return (
    <a href={href} rel="noreferrer" target="_blank" {...rest}>
      {children}
    </a>
  )
}
